import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Input,
    Button,
    FormControl,
    FormLabel,
    useDisclosure,
    Box,
    Center,
    VStack,
    HStack,
  } from "@chakra-ui/react";
import React,{useState} from "react"
import axios from "axios"
import { useToast } from '@chakra-ui/react'

function NotesAdd() {
    const { isOpen, onOpen, onClose } = useDisclosure()
     const [subject,setSubject]=useState(null)
     const [topic,setTopic]=useState(null)
     const [url,setUrl]=useState(null)
     const [loading ,setLoading]=useState(false)
    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)
    const toast=useToast()

  const handleSubmit=async()=>{
   
     if(subject==null || topic==null || url==null){

        alert("Please correct all the details.")
        return ;
     }else{
        alert("Are you sure you want to add notes")
        setLoading(true)
        try{
            const res=await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/notes`,{subject,topic,url})
            toast({
                title: 'Successfully Add Notes',
                description: "",
                status: 'success',
                duration: 1000,
                isClosable: true,
                position: 'bottom-center',
              })
            
        }catch(err){
            toast({
                title: 'Not Add Notes',
                description: "",
                status: 'error',
                duration: 1000,
                isClosable: true,
                position: 'bottom-center',
              })
        }
     }
     setSubject(null)
     setTopic(null)
     setUrl(null)
     setLoading(false)
  }


    return (
      <>
        <Button colorScheme="teal" onClick={onOpen}>Add Notes</Button>
        
  
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add Notes</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Subject</FormLabel>
                <Input ref={initialRef} value={subject} onChange={(e)=>setSubject(e.target.value)} placeholder='Enter Subject Name' />
              </FormControl>
  
              <FormControl mt={4}>
                <FormLabel>Topic</FormLabel>
                <Input placeholder='Enter Chapter name' value={topic} onChange={(e)=>setTopic(e.target.value)} />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Google Drive Link</FormLabel>
                <Input placeholder='Enter link'value={url} onChange={(e)=>setUrl(e.target.value)}/>
              </FormControl>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3} isLoading={loading} onClick={handleSubmit}>
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
  export default NotesAdd